import { cabinClassRank, logErrorToConsole } from '../../constants';
import getAllCabinsInFlightItinerary from './getAllCabinsInFlightItinerary';

const getHighestRankedCabinFlightItinerary = (flightItinerary) => {
  try {
    const cabins = getAllCabinsInFlightItinerary(flightItinerary);

    if (!Array.isArray(cabins)) throw Error('invalid cabins passed.');
    return cabins.reduce((highest, cabin) => (cabinClassRank[cabin] > cabinClassRank[highest]
      ? cabin : highest), cabins[0]);
  } catch (error) {
    logErrorToConsole('[ERROR] occured in getHighestRankedCabinFlightItinerary: ', error);
    return '';
  }
};

export default getHighestRankedCabinFlightItinerary;
